import { Modal } from "antd";
import classNames from "classnames";
import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { NAME_SPACES } from "shared/locales/constants";
import { bindInputProps } from "utils/helpers/input";
import ActionButtons from "../Components/ActionButtons";
import Button from "../Components/Button";
import CustomModal from "../Components/CustomModal";
import Head from "../Components/Head";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import Radio from "../Components/Radio";
import checkMarkSmall from "../Components/svg/check_small-secondary.svg";
import euroIcon from "../Components/svg/euro-icon.svg";
import euroSign from "../Components/svg/euro.svg";
import validation from "./validation";

const formulas = [
  {
    label: "ECONOMIC",
    value: 1,
  },
  {
    label: "ESSENTIAL",
    value: 2,
  },
  {
    label: "COMFORT",
    value: 3,
  },
  {
    label: "OPTIMAL",
    value: 4,
  },
  {
    label: "CUSTOM",
    value: null,
  },
];

const View = ({ fields, onNext, onBack }) => {
  const [open, setOpen] = useState(false);
  const [selectedFormulaHelp, setSelectedFormulaHelp] = useState(null);
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const TRANSLATION = t("B2C_LMF.COLLECTION_OF_NEEDS", { returnObjects: true });

  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues: fields,

    onSubmit: onNext,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true })
    ),
  });
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <>
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        width={400}
        footer={null}
        centered
        className="LMF-formula-modal"
      >
        <>
          <span className="LMF-formula-modal__title">
            {TRANSLATION.MODAL.FORMULA} "
            {
              TRANSLATION.FORMULAS[
                formulas.find(
                  ({ value }) => value === selectedFormulaHelp
                )?.label
              ]?.LABEL
            }
            "
          </span>
          <div className="LMF-formula-modal__content">
            <ul>
              {(
                TRANSLATION.FORMULAS[
                  formulas.find(
                    ({ value }) => value === selectedFormulaHelp
                  )?.label
                ]?.ADVANTAGES || []
              ).map((item, index) => (
                <li key={index}>
                  <img src={checkMarkSmall} alt="✔" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <Button
            onClick={() => setOpen(false)}
            className="w-full"
            type="white"
            size="middle"
          >
            <span>{TRANSLATION.CLOSE}</span>
          </Button>
        </>
      </Modal>
      <CustomModal
        open={open}
        setOpen={setOpen}
        title={
          <>
            {TRANSLATION.MODAL.FORMULA} "
            {
              TRANSLATION.FORMULAS[
                formulas.find(
                  ({ value }) => value === selectedFormulaHelp
                )?.label
              ]?.LABEL
            }
            "
          </>
        }
        width={420}
        TRANSLATION={TRANSLATION}
        closeText={TRANSLATION.MODAL.CLOSE}
      >
        <ul className="lmf__list">
          {(
            TRANSLATION.FORMULAS[
              formulas.find(
                ({ value }) => value === selectedFormulaHelp
              )?.label
            ]?.ADVANTAGES || []
          ).map((item, index) => (
            <li key={index}>
              <img src={checkMarkSmall} alt="✔" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </CustomModal>

      <Layout>
        <Head
          description={TRANSLATION.DESCRIPTION}
          title={TRANSLATION.TITLE}
          onBack={onBack}
        />
        <div className="__LMF--content LMF-content lmf__form">
          <Radio
            type="list"
            disabled={false}
            values={formulas
              .filter(({ value }) => {
                return !(get(values, "selectedLevel") === null && value === null);
              })
              .map(({ value, label }) => ({
                label: TRANSLATION.FORMULAS[label].LABEL,
                value,
                subLabel: TRANSLATION.FORMULAS[label].SUB_LABEL,
                onHelpClick: (v) => {
                  setSelectedFormulaHelp(v);
                  setOpen(true);
                },
              }))}
            {...bindInputProps({
              name: "selectedLevel",
              values,
              setFieldValue,
              ...formProps,
            })}
            onChange={async (value) => {
              setFieldValue("selectedLevel", value);
              setFieldValue("budget", null);
              await formProps.validateForm();
              formProps.setFieldTouched(`selectedLevel`);
            }}
          />
          {get(values, "selectedLevel") === null && (
            <div className="lmfCustom__budget">
              <img src={euroIcon} alt="" />
              <Input
                label={TRANSLATION.FORM.BUDGET.LABEL}
                placeholder={TRANSLATION.FORM.BUDGET.PLACEHOLDER}
                className={classNames({
                  valid: get(values, "budget"),
                })}
                type={"number"}
                inputMode="numeric"
                {...bindInputProps({
                  name: `budget`,
                  values,
                  setFieldValue,
                  ...formProps,
                })}
                value={
                  get(values, "budget.min") && get(values, "budget.max")
                    ? Math.round((get(values, "budget.min") + get(values, "budget.max")) / 2)
                    : get(values, "budget") || ""
                }
                onChange={({ target: { value } }) => {
                  const numValue = parseInt(value);
                  setFieldValue(`budget`,
                    value === "" || isNaN(numValue) || numValue <= 0
                      ? null
                      : { min: numValue - 50, max: numValue + 50 }
                  );
                }}
                suffix={<img src={euroSign} alt="" />}
                disabled={false}
              />
            </div>
          )}
        </div>

        <ActionButtons
          disabled={!isEmpty(formProps.errors)}
          onNext={handleSubmit}
          buttonText={TRANSLATION.NEXT}
          {...(isMobile && { onBack })}
          className={classNames({
            "w-100": isMobile,
          })}
        />
      </Layout>
    </>
  );
};

export default View;
